// extracted by mini-css-extract-plugin
export var aiStarIcon = "_aw-4";
export var closeButton = "_aw-6";
export var dismissButton = "_aw-3";
export var editImageWithAiContainer = "_aw-8";
export var imageUploadWrapper = "_aw-7";
export var misspelledWord = "_aw-5";
export var spellCheckContainer = "_aw-2";
export var spin = "_aw-1";
export var spinning = "_aw-0";